import axios from "axios";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useCookies } from "react-cookie";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import MaskedInput from "react-text-mask";
import globalContext from "../../Contexts/GlobalContext";
import BlueLoader from "../loader/BlueLoader";
import "./ChangeKmModal.css";
import ChangeKmsConf from "../modals/ChangeKmsConf";
import MessageModals from "../modals/MessageModals";
import { SERVERMESSAGE } from "../../constants/serverMessage";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import { addCommas, p2e, removeNonNumeric } from "../../utils/functions";
import useRequestHeader from "../../hooks/useRequestHeader";
export default function ChangeKmModal({ SMFMethod }) {
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  /// root api address section end ///
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const requestHeader = useRequestHeader();
  const [cookies, setCookies, removeCookies] = useCookies();
  const contextData = useContext(globalContext);
  const [kmCurrent, setKmCurrent] = useState(0);
  const [kmCurrentInp, setKmCurrentInp] = useState(0);

  const [IsKmUpdateConfOpen, setIsKmUpdateConfOpen] = useState(false);
  const [kmUpdateConfMessage, setkmUpdateConfMessage] = useState("");
  const [kmUpdateConfTitle, setKmUpdateConfTitle] = useState("");
  // ------->
  useEffect(() => {
    setKmCurrent(contextData?.changeKmModalKM);
    setKmCurrentInp(contextData?.changeKmModalKM);
  }, []);
  const increaseKm = () => {
    setKmCurrentInp(
      (prev) => Number(prev.toString()?.replaceAll(",", "")) + 500
    );
  };
  const decreaseKm = () => {
    if (kmCurrentInp?.toString()?.replaceAll(",", "") - 500 > 0)
      setKmCurrentInp(
        (prev) => Number(prev?.toString()?.replaceAll(",", "")) - 500
      );
  };
  // ------->
  const updateKm = (ok, setIsLoadingDataConf) => {
    let sendParams = {};
    if (SMFMethod) {
      sendParams = {
        plate: cookies?.plate,
        kmCurrent: `${kmCurrentInp?.toString()?.replaceAll(",", "")}`,
        method: "smf",
      };
    } else {
      sendParams = {
        plate: cookies?.plate,
        kmCurrent: `${kmCurrentInp?.toString()?.replaceAll(",", "")}`,
      };
    }
    if (Number(kmCurrentInp?.toString()?.replaceAll(",", "")) > 0) {
      setIsLoading(true);
      if (ok === "true") {
        sendParams.isValid = "true";
      }
      const config = {
        headers: requestHeader,
      };
      axios
        .post(`${BASE_URL}/service/updateKmCurrent`, sendParams, config)
        .then((res) => {
          var responseMode = res?.data?.Mode;
          var responseMessage = res?.data?.Message;
          switch (responseMode) {
            case SERVERMODE.REQUEST_OK: {
              contextData.setChangeKmModalKM(
                kmCurrentInp?.toString()?.replaceAll("", "")
              );
              contextData.setChangeKmModalIsOpen(false);
              setCookies(
                "kmCurrent",
                kmCurrentInp?.toString()?.replaceAll("", ""),
                {
                  path: "/",
                }
              );
              setIsLoading(false);
              if (window.location.pathname === "/short-terms") {
                window.location.reload();
              }
              navigate("/short-terms");
              break;
            }
            case SERVERMODE.DATA_ILLOGICAL: {
              setIsKmUpdateConfOpen(true);
              setkmUpdateConfMessage(res?.data?.Message);
              setKmUpdateConfTitle("ثبت کیلومتر کارکرد نامعقول");
              break;
            }
            default: {
              handleServerMode(
                responseMode,
                responseMessage,
                contextData,
                cookies,
                removeCookies,
                navigate,
                res?.data?.Message
              );
            }
          }

          if (res?.data?.Error) {
            contextData.setIsToastOpen(true);
            contextData.setToastMessage(res?.data?.Message);
          }
          setIsLoading(false);
          if (setIsLoadingDataConf) setIsLoadingDataConf(false);
        })
        .catch((err) => {
          setIsLoading(false);
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
        });
    }
  };
  return (
    <div
      className="absolute w-full h-screen top-0 backdrop-blur-sm flex items-center justify-center z-[1000]"
      id="bg"
      onClick={(e) => {
        if (e.target.id === "bg") contextData.setChangeKmModalIsOpen(false);
      }}
    >
      {IsKmUpdateConfOpen && (
        <ChangeKmsConf
          setIsKmUpdateConfOpen={setIsKmUpdateConfOpen}
          sendAllData={updateKm}
          message={kmUpdateConfMessage}
          title={kmUpdateConfTitle}
        />
      )}
      <div
        className={`relative w-[80vw] pb-[3vw] bg-[#001D26]  flex flex-col items-center justify-center z-[800] rounded-[1vw] border-[1px] border-color-primary-D gap-y-[3.7vw]`}
      >
        <div
          className="w-full flex items-center justify-center bg-color-primary-D font-font_primary_A text-[#153038] "
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span className="py-[2vw]"> کیلومتر کارکرد</span>
        </div>
        <span
          className={`w-full flex items-center justify-center text-[4vw] z-[800] text-color-primary-C3 font-font_primary_A`}
        >
          کارکرد فعلی خودرو را ثبت نمایید
        </span>

        <div className="w-[62.26415094339623vw] h-[11.28301886792453vw] flex items-center justify-between px-[1.5vw] rounded-[1.504716981132075vw] border-[1px] border-color-primary-C3">
          <span className="text-[4.245283018867925vw] text-color-primary-C3 font-font_primary_A ">
            کیلومتر قبلی
          </span>
          <span className="text-[7.547169811320755vw] font-font_primary_D sptext">
            {addCommas(removeNonNumeric(p2e(kmCurrent)))}
          </span>
        </div>
        <div
          dir="ltr"
          className="w-[62.26415094339623vw] flex items-center justify-between"
        >
          <input
            type="text"
            dir="ltr"
            maxLength={7}
            value={addCommas(removeNonNumeric(p2e(kmCurrentInp)))}
            className="w-[48.34905660377358vw] h-[11.32075471698113vw] border-[1px] pl-[2vw] border-color-primary-D bg-transparent rounded-[1.886792452830189vw] z-[50] text-[9vw] focus:text-[9vw] font-font_primary_D focus:font-font_primary_D text-color-primary-D focus:text-color-primary-D outline-none  "
            onChange={(e) => {
              setKmCurrentInp(addCommas(removeNonNumeric(p2e(e.target.value))));
            }}
          />
          <div className="flex flex-col items-start justify-between h-full">
            <div
              className="relative top-0 w-[11.32075471698113vw]"
              onClick={increaseKm}
            >
              <svg
                width="11.32075471698113vw"
                height="5vw"
                viewBox="0 0 48 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_53_88)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.44444 0H41.7778C45.1111 0 48 2.88889 48 6.44444V20H0V6.44444C0 2.88889 2.88889 0 6.44444 0ZM24 6L26.2222 10L28.6667 14H24H19.3333L21.7778 10L24 6Z"
                    fill="#00FFF2"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_53_88">
                    <rect width="48" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div
              className="relative top-0 mt-[1.8vw] w-[11.32075471698113vw] "
              onClick={decreaseKm}
            >
              <svg
                width="11.32075471698113vw"
                height="5vw"
                viewBox="0 0 150 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_53_80)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M149.828 0V42.7586C149.828 53.4483 141.276 62 130.586 62H19.4137C8.72409 62 0.172363 53.4483 0.172363 42.7586V0L149.828 0ZM74.9999 42.7586L81.4137 32.069L89.9655 19.2414H74.9999H60.0344L68.5862 32.069L74.9999 42.7586Z"
                    fill={`${
                      kmCurrentInp?.toString()?.replaceAll(",", "") - 500 > 0
                        ? "#00FFF2"
                        : "#9E9B96"
                    }`}
                  />
                </g>
                <defs>
                  <clipPath id="clip0_53_80">
                    <rect width="150" height="62" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between gap-x-[1vw]">
          {isLoading ? (
            <div className="relative w-[62.26415094339623vw] h-[11.28301886792453vw]  rounded-[0.78125vw] text-center flex items-center justify-center text-[#474747] font-font_primary_A text-[5vw] bg-color-primary-D z-[1000]">
              <BlueLoader position="" width={7} />
            </div>
          ) : (
            <button
              className={`relative w-[62.26415094339623vw] h-[11.28301886792453vw] rounded-[0.78125vw] text-center flex items-center justify-center text-[#474747] font-font_primary_A text-[5vw] ${
                0 < Number(kmCurrentInp?.toString()?.replaceAll(",", ""))
                  ? "bg-color-primary-D"
                  : "bg-color-primary-C3"
              } z-[1000]`}
              onClick={updateKm}
            >
              ثبت
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
